/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Nav_Reply_IncompleteInputs */



/**
* | output |
* | --- |
* | "Event has reply marked as incomplete." |
*
* @param {Error_Nav_Reply_IncompleteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const error_nav_reply_incomplete = /** @type {((inputs?: Error_Nav_Reply_IncompleteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Nav_Reply_IncompleteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("L'evenement a une reponse marquee comme incomplete.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Antwort auf die Veranstaltung ist unvollständig.")
	if (locale === "it") return /** @type {LocalizedString} */ ("La risposta all'evento è stata contrassegnata come incompleta.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("В сообщении отмечен ответ, который не завершен.")
	if (locale === "es") return /** @type {LocalizedString} */ ("El evento tiene la respuesta marcada como incompleta.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("活动回复被标记为未完成。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントの返信が未完了としてマークされています。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इस इवेंट का जवाब अधूरा है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("O evento teve a resposta marcada como incompleta.")
	return /** @type {LocalizedString} */ ("Event has reply marked as incomplete.")
});